import { Box, Button, TextField, Typography } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Verify2FAProps {
 verificationCode: string;
 onVerificationCodeChange: (code: string) => void;
 onVerifyTotp: () => void;
 loading: any;
 method: 1 | 2;
 control: Control<any>;
 setTwoFactorAuthMethod: (method: 1 | 2 | null) => void;
}
const Verify2FA = ({
 verificationCode,
 onVerificationCodeChange,
 onVerifyTotp,
 loading,
 method,
 control,
 setTwoFactorAuthMethod,
}: Verify2FAProps) => {
 const { t } = useTranslation();
 return (
  <Box
   sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    backgroundColor: (th) => th.palette.kemek.lightBlue,
    p: '12px',
    mt: '12px',
   }}
  >
   <Typography sx={{ fontSize: 14 }}>
    {t('user.twoFactor.verifyPhone')}
   </Typography>
   <Controller
    name="verificationCode"
    control={control}
    rules={{
     required: t('user.errors.required', {
      field: t('user.twoFactor.enterCode'),
     }),
    }}
    render={({ field }) => (
     <TextField
      fullWidth
      label={t('user.twoFactor.enterCode')}
      value={verificationCode}
      onChange={(e) => onVerificationCodeChange(e.target.value)}
     />
    )}
   />
   <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
    <Button
     variant="outlined"
     color="secondary"
     onClick={() => setTwoFactorAuthMethod(null)}
    >
     {t('global.cancel')}
    </Button>
    <Button
     variant="outlined"
     color="primary"
     onClick={onVerifyTotp}
     disabled={!verificationCode || loading?.identityVerifyTotp === true}
     sx={{}}
    >
     {t('user.twoFactor.verify')}
    </Button>
   </Box>
  </Box>
 );
};

export default Verify2FA;

